import React, { } from 'react';
import { Link } from 'react-router-dom';
import { Flex, FlexItem } from '@bigcommerce/big-design';

const headerStyle = {
  background: '#000',
  color: '#fff',
  textAlign: 'center',
  padding: '10px'
}

const linkStyle = {
  color: '#fff',
  padding: '0 12px'
}

export default function Header({ token }) {

  const logout = () => {
    sessionStorage.removeItem('token');
    window.location = `/`;
  }

  const loggedIn = () => {
    return <div style={headerStyle}>
      <Flex
        alignContent="stretch"
        alignItems="center"
        flexDirection="row"
        justifyContent="center"
        flexWrap="nowrap"
      >
        <FlexItem alignSelf="auto" flexBasis="auto" flexGrow={0} flexOrder={0} flexShrink={1}>
          <Link style={linkStyle} to="/">Home</Link>
        </FlexItem>
        <FlexItem alignSelf="auto" flexBasis="auto" flexGrow={0} flexOrder={0} flexShrink={1}>
          <Link style={linkStyle} to="/purchase-order">Purchase Order</Link>
        </FlexItem>
        <FlexItem alignSelf="auto" flexBasis="auto" flexGrow={0} flexOrder={0} flexShrink={1}>
          <Link style={linkStyle} to="/webhooks">Webhooks</Link>
        </FlexItem>
        <FlexItem alignSelf="auto" flexBasis="auto" flexGrow={0} flexOrder={0} flexShrink={1}>
          <Link style={linkStyle} to="/reviews">Reviews</Link>
        </FlexItem>
        <FlexItem alignSelf="auto" flexBasis="auto" flexGrow={0} flexOrder={0} flexShrink={1}>
          <button className="btn" onClick={(e) => logout()}>Logout</button>
        </FlexItem>
        {/* <FlexItem alignSelf="auto" flexBasis="auto" flexGrow={0} flexOrder={0} flexShrink={1}>
          <Link style={linkStyle} to="/csv-generator">CSV Generator</Link>
        </FlexItem> */}
      </Flex>
    </div>
  }

  const loggedOut = () => {
    return <div style={headerStyle}>
      <Flex
        alignContent="stretch"
        alignItems="center"
        flexDirection="row"
        justifyContent="center"
        flexWrap="nowrap"
      ></Flex>
    </div>
  }

  return (
    <>
      {token ? loggedIn() : loggedOut()}
    </>
  )
}